import React, { useEffect } from "react";
import {BrowserRouter as Router,useNavigate,useLocation} from "react-router-dom";
import Header from "./HomePage/Header";
import AfterLoginRoutes from "./Routes/AfterLoginRoutes";
import Footer from "./HomePage/Fooder";
import "./App.css";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return !!token;
};

const getUserRole = () => localStorage.getItem("role");

const isClientUser = () => getUserRole() === "user";

const AppWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll to top on every route change (including browser back/forward)
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname, location.search, location.key]);

  useEffect(() => {
    const path = location.pathname;
    if (isAuthenticated()) {
      if (path === "/" || path === "/login") {
        if (isClientUser()) {
          navigate("/client/overview");
        } else {
          navigate("/card");
        }
      }
      if (
        isClientUser() &&
        !path.startsWith("/client") &&
        !path.startsWith("/user-app") &&
        path !== "/login"
      ) {
        navigate("/client/overview");
      }
      if (!isClientUser() && path.startsWith("/client")) {
        navigate("/card");
      }
    } else {
      if (path !== "/login") {
        navigate("/login");
      }
    }
  }, [location.pathname, navigate]);

  const authenticated = isAuthenticated();
  const clientUser = isClientUser();
  const onClientRoute =
    location.pathname.startsWith("/client") || location.pathname.startsWith("/user-app");
  // The admin "view as user" dashboard (`/admin/users/:email/*`) renders the
  // client shell, so hide the admin Header/Footer there. The list page
  // (`/admin/users`) keeps the admin chrome.
  const onAdminUserDashboard = location.pathname.startsWith("/admin/users/");
  const showAdminChrome =
    authenticated && !clientUser && !onClientRoute && !onAdminUserDashboard;

  return (
    <div className="app-shell">
      {showAdminChrome && <Header />}
      <div className="app-content">
        <AfterLoginRoutes />
      </div>
      {showAdminChrome && <Footer />}
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
};

export default App;
